import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Maincomponent from './Maincomponents/Manicomponent';
import Maintestingcomponents from './testingcomponents/Maintestingcomponents';
import Mainjavacomponents from './javacomponents/Mainjavacomponents';
import Mainpythoncomponents from './pythoncomponents/Mainpythoncomponents';
import Maindotnetcomponents from './dotnetcomponents/Maindotnetcomponents';
import Maindevopscomponents from './devopscomponents/Maindevopscomponents';
import Mainawscomponents from './awscomponents/Mainawscomponents';
import Mainazurecomponents from './azurcomponents/Mainazurecomponents';
import Mainuiuxcomponents from './uiuxcomponents/Mainuiuxcomponents';
import Mainaicomponents from './aicomponents/Mainaicomponents';
import Maindatasciencecomponents from './datasciencecomponents/Maindatasciencecomponents';
import Maindataanalysiscomponents from './dataanalysiscomponents/Maindataanalysiscomponents';
import Mainfrontendcomponents from './frontendcomponents/Mainfrontendcomponents';
import ThankYouai from './aicomponents/thankyou/Thankyou';
import ThankYouui from './uiuxcomponents/thankyou/Thankyou';
import ThankYoutesting from './testingcomponents/thankyou/Thankyou';
import ThankYoupython from './pythoncomponents/thankyou/Thankyou';
import ThankYoujava from './javacomponents/thankyou/Thankyou';
import ThankYoufront from './frontendcomponents/thankyou/Thankyou';
import ThankYoudotnet from './dotnetcomponents/thankyou/Thankyou';
import ThankYoudevops from './devopscomponents/thankyou/Thankyou';
import ThankYoudatascience from './datasciencecomponents/thankyou/Thankyou';
import ThankYoudataana from './dataanalysiscomponents/thankyou/Thankyou';
import ThankYouazure from './azurcomponents/thankyou/Thankyou';
import ThankYouaws from './awscomponents/thankyou/Thankyou';
import ThankYoudataanadataana from './dataanalysiscomponents/thankyou/Thankyou';
import ThankYoufrontend from './frontendcomponents/thankyou/Thankyou';
import ThankYou from './Maincomponents/thankyou/Thankyou';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Default Route */}
          <Route path="/" element={<Maincomponent />} />

          {/* Software Testing Page Route */}
          <Route path="/software-testing-in-chennai" element={<Maintestingcomponents />} />
          <Route path='/java-course-in-chennai' element={<Mainjavacomponents />} />
          <Route path='/python-course-in-chennai' element={<Mainpythoncomponents />} />
          <Route path="/dotnet-course-in-chennai" element={<Maindotnetcomponents />} />
          <Route path="/devops-course-in-chennai" element={<Maindevopscomponents />} />
          <Route path="/aws-course-in-chennai" element={<Mainawscomponents />} />
          <Route path="/azure-course-in-chennai" element={<Mainazurecomponents />} />
          <Route path="/uiux-course-in-chennai" element={<Mainuiuxcomponents />} />
          <Route path='/ai-course-in-chennai' element={<Mainaicomponents />} />
          <Route path='/datascience-course-in-chennai' element={<Maindatasciencecomponents />} />
          <Route path='/analist-course-in-chennai' element={<Maindataanalysiscomponents />} />
          <Route path="/frontend-course-in-chennai" element={<Mainfrontendcomponents />} />


          <Route
            path="/ai-course-in-chennai/thank-you"
            element={<ThankYouai />}
          />
          
          <Route
            path="/software-testing-in-chennai/thank-you"
            element={<ThankYoutesting />}
          />
          <Route
            path="/java-course-in-chennai/thank-you"
            element={<ThankYoujava />}
          />
          <Route
            path="/python-course-in-chennai/thank-you"
            element={<ThankYoupython />}
          />
          <Route
            path="/dotnet-course-in-chennai/thank-you"
            element={<ThankYoudotnet />}
          />
          <Route
            path="/devops-course-in-chennai/thank-you"
            element={<ThankYoudevops />}
          />
          <Route
            path="/aws-course-in-chennai/thank-you"
            element={<ThankYouaws />}
          />
          <Route
            path="/azure-course-in-chennai/thank-you"
            element={<ThankYouazure />}
          />
          <Route
            path="/uiux-course-in-chennai/thank-you"
            element={<ThankYouui />}
          />
           <Route
            path="/datascience-course-in-chennai/thank-you"
            element={<ThankYoudatascience />}
          />
           <Route
            path="/analist-course-in-chennai/thank-you"
            element={<ThankYoudataanadataana />}
          />
           <Route
            path="/frontend-course-in-chennai/thank-you"
            element={<ThankYoufrontend />}
          />
           
           <Route path = "/thankyou" element = {<ThankYou/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;